// Import the createApp function from Vue
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "@fortawesome/fontawesome-free/css/all.css";
import state from "./state";
import "@/assets/tailwind.css";
import 'v-calendar/style.css';
// import ConfirmPopup from 'primevue/confirmpopup';
import VCalendar from 'v-calendar';
import { Icon } from "@iconify/vue";
import axios from "axios";
import { iniciarBotaoVoltar } from "@/native/backButton";
import { aplicarCoresDoUsuario } from "@/utils/themeUtils.js";
import { compressFormDataImages } from "@/utils/imageCompression.js";
import Vue3Toastify, { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

// Import validation configuration
import './validations/config.js';

// Correct the import statement for the Vue 3 compatible Google Maps package
import { GoogleMap, Marker, Polyline, InfoWindow } from 'vue3-google-map'
const baseURL = process.env.VUE_APP_URL_BASE;

axios.interceptors.request.use(
  async (config) => {
    const userToken = localStorage.getItem("token");

    if (userToken) {
      const cleanToken = userToken.replace(/^["'](.*)["']$/, "$1");
      config.headers["Authorization"] = `Bearer ${cleanToken}`;
    }

    const empresa = localStorage.getItem("selectedSchema") || "safetycv";
    config.headers["X-Schema"] = empresa;

    // Shrink photos client-side so uploads are small on slow connections.
    if (config.data instanceof FormData) {
      config.data = await compressFormDataImages(config.data);
    }

    return config;
  },
  (error) => {
    console.error("Erro no Interceptor:", error);
    return Promise.reject(error);
  }
);


let _redirectingToLogin = false;

function clearAuthAndRedirect() {
  if (_redirectingToLogin) return;
  _redirectingToLogin = true;

  localStorage.removeItem('token');
  localStorage.removeItem('isLoggedIn');
  localStorage.removeItem('user');

  const currentPath = window.location.pathname;
  if (currentPath !== '/' && currentPath !== '') {
    toast.error('Sessão expirada. Por favor, faça login para continuar.');
    router.push('/').finally(() => { _redirectingToLogin = false; });
  } else {
    _redirectingToLogin = false;
  }
}

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      clearAuthAndRedirect();
    }
    return Promise.reject(error);
  }
);

const app = createApp(App);

app.use(router);
app.component("Icon", Icon);
app.use(state);

app.use(Vue3Toastify, {
  autoClose: 3000,
  clearOnUrlChange: false,
  theme: "dark",
  toastStyle: {
    background: "var(--fundoComponente)", // #626288
    color: "white",
  },
  successToast: {
    background: "var(--verde-claro)", // #28a745
  },
  errorToast: {
    background: "var(--vermelho)", // #e40202e8
  },
  infoToast: {
    background: "var(--azul)", // #006698
  },
  warningToast: {
    background: "var(--amarelo)", // #d78100
  },
});

// app.use(VueGoogleMap, {
//   load: {
//     key: "", // Replace 'YOUR_API_KEY' with your actual Google Maps API key
//     libraries: "places", // necessary for places input
//   },
// });

app.component('GoogleMap', GoogleMap)
app.component('Marker', Marker)
app.component('Polyline', Polyline)
app.component('InfoWindow', InfoWindow)
app.config.globalProperties.$baseURL = baseURL;

// Add global error handler to catch Vue component errors
app.config.errorHandler = (err, instance, info) => {
  console.error('Vue Global Error Handler:');
  console.error('Error:', err);
  console.error('Component:', instance);
  console.error('Info:', info);

  // Check for specific insertBefore error
  if (err.message && err.message.includes("insertBefore")) {
    console.error('=== INSERT_BEFORE ERROR DETECTED ===');
    console.error('Component name:', instance?.$options?.name || instance?.$?.type?.name || 'Unknown');
    console.error('Component props:', instance?.$props);
    console.error('Component data:', instance?.$data);
    console.error('Stack trace:', err.stack);
    console.error('=====================================');
  }
};

app.mount("#app");
iniciarBotaoVoltar(router);
// aplicarCoresDoUsuario(baseURL).then(() => {
// });
